
<div class="main">
  <div class="droparea" (drop)="onDrop($event)" (dragover)="onDragover($event)">
    @if (files.length<1) {
      <p class="uploadHint">Dateien in dieses Feld ziehen</p>
    }
    @if (files.length>0) {
      <div class="scrollArea">
        @for (file of files; track file) {
          <app-fileUploadItem  #items [file]="file"
            [title]="title"
            (setFileInfo)="onSetFileInfo($event)"
            (setDone)="removeFile($event)">
          </app-fileUploadItem>
        }
      </div>
    }
  </div>
</div>
<div class="buttonline" #buttonline>
  <div class="left">
    @if (files.length>0) {
      <span>Verbleibend: {{files.length}} Dateien, {{getFileSizeTotal() | fileSize}}</span>
    }
    @if (files.length==0) {
      <h2>{{getFiletypesDescription()}}</h2>
    }
  </div>
  <div class="right">
    <button mat-button  title="Datei-Auswahl" (click)="onUpload($event)"><i class="material-icons">upload</i>Hochladen</button>
    <button mat-button  title="alle abbrechen" (click)="onClearAll($event)" [disabled]="files.length<1"><i class="material-icons">clear</i>Abbrechen</button>
  </div>
</div>
<input ng2FileSelect type="file" (change)="selectFiles($event)" #fileInput hidden="hidden" [multiple]="true" />
